import React, { Fragment } from "react";

import img13 from "../../../images/service/E-Commerce Blockchain Development/crypto.png";
import img14 from "../../../images/service/E-Commerce Blockchain Development/crypto (2).png";
import img15 from "../../../images/service/E-Commerce Blockchain Development/crypto (3).png";

// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Cryptocurrency Exchange Development",
    content:
      "Build secure, high-performance centralized and decentralized exchanges for trading digital assets with advanced features.",
  },
  {
    icon: sIcon2,
    title: "Crypto Wallet Solutions",
    content:
      "Develop custodial and non-custodial wallets with multi-signature support and hardware wallet integration.",
  },
  {
    icon: sIcon3,
    title: "Token Launch & ICO/IEO Platforms",
    content:
      "Create compliant token launch platforms with smart contract development for fundraising and token distribution.",
  },
];

const benefits = [
  {
    title: "Decentralized Control",
    description:
      "Empower users with full control over their digital assets without relying on centralized authorities or intermediaries.",
    icon: sIcon1,
  },
  {
    title: "Global Accessibility",
    description:
      "Enable borderless transactions and 24/7 trading access for users worldwide without geographic restrictions.",
    icon: sIcon2,
  },
  {
    title: "Enhanced Security",
    description:
      "Cryptographic protocols and distributed architecture provide superior protection against hacks and unauthorized access.",
    icon: sIcon3,
  },
  {
    title: "Lower Transaction Fees",
    description:
      "Eliminate intermediaries and reduce processing costs for faster, cheaper transfers compared to traditional systems.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "What is crypto blockchain development?",
    a: "Crypto blockchain development involves building cryptocurrency exchanges, wallets, token systems, and DeFi platforms using blockchain technology for secure digital asset management and trading.",
  },
  {
    q: "How does blockchain enable cryptocurrency?",
    a: "Blockchain provides the distributed ledger infrastructure that records all cryptocurrency transactions transparently, ensures security through cryptography, and enables decentralized consensus without central authority.",
  },
  {
    q: "What types of crypto platforms can be built?",
    a: "We develop centralized/decentralized exchanges, crypto wallets, token launch platforms, DeFi protocols, staking platforms, NFT marketplaces, and custom blockchain networks.",
  },
  {
    q: "Is blockchain secure for crypto transactions?",
    a: "Yes—blockchain's cryptographic security, consensus mechanisms, and distributed architecture make crypto transactions highly secure and resistant to fraud, tampering, and unauthorized access.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function CryptoBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Crypto Blockchain Development"
        pagesub="Build secure, scalable cryptocurrency platforms and DeFi solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Power the{" "}
            <span className="gradient-text">Crypto Economy</span>{" "}
            with Blockchain
          </>
        }
        subtitle={`Develop cutting-edge cryptocurrency platforms, exchanges, wallets, and DeFi applications that 
provide secure, transparent, and efficient digital asset management for the global crypto ecosystem.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Crypto Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Blockchain for Cryptocurrency?"
        image={img14}
        paragraphs={[
          "Blockchain is the foundational technology that enables cryptocurrencies to exist as decentralized, secure digital assets. Its distributed ledger ensures transparency, immutability, and trustless transactions without central authority.",
          "From Bitcoin to DeFi protocols, blockchain provides the infrastructure for a new financial paradigm that empowers users with direct control over their assets and enables innovative financial services globally.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Core Crypto Blockchain Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Evolution of the Crypto Ecosystem"
        image={img15}
        paragraphs={[
          "The cryptocurrency ecosystem has evolved from simple digital currencies to complex DeFi platforms, NFT marketplaces, metaverse applications, and cross-chain interoperability solutions.",
          "Blockchain technology continues to advance with layer-2 scaling solutions, improved consensus mechanisms, and enhanced smart contract capabilities that enable more sophisticated crypto applications and use cases.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Blockchain in Crypto"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Crypto Blockchain Solutions"
        subtitle="Build robust infrastructure for the future of digital assets"
        features={[
          {
            icon: sIcon1,
            title: "High-Performance Trading",
            description:
              "Order matching engines capable of processing thousands of transactions per second.",
          },
          {
            icon: sIcon2,
            title: "Multi-Asset Support",
            description:
              "Support for Bitcoin, Ethereum, altcoins, tokens, and stablecoins on multiple chains.",
          },
          {
            icon: sIcon3,
            title: "Advanced Security",
            description:
              "Cold storage, multi-signature wallets, and encryption protect user assets comprehensively.",
          },
          {
            icon: sIcon4,
            title: "Liquidity Management",
            description:
              "Integrated liquidity pools, AMM protocols, and order book systems for optimal trading.",
          },
          {
            icon: sIcon5,
            title: "Regulatory Compliance",
            description:
              "Built-in KYC/AML, transaction monitoring, and reporting for regulatory requirements.",
          },
          {
            icon: sIcon6,
            title: "Cross-Chain Bridges",
            description:
              "Enable seamless asset transfers between different blockchain networks and ecosystems.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Expert team with deep crypto and blockchain development experience",
          "Security-first approach with comprehensive audit and testing",
          "End-to-end solutions from architecture to deployment and maintenance",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
